import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flex: 1,
    alignItems: 'flex-end',
  },
}))
